module.exports = __webpack_public_path__ + "static/media/client11.bd90442d.webp";